import { render, staticRenderFns } from "./ServiceItem.vue?vue&type=template&id=385bf76c&scoped=true"
import script from "./ServiceItem.vue?vue&type=script&lang=ts"
export * from "./ServiceItem.vue?vue&type=script&lang=ts"
import style0 from "./ServiceItem.vue?vue&type=style&index=0&id=385bf76c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385bf76c",
  null
  
)

export default component.exports